import { SharedReportListItemApiModel } from '../../../api/reports/model/shared-report-api.model';
import { basicClone, Clonable } from '../../Basic/decorators/clone.decorator';
import { TimeHelper } from '../../Forms/helpers/time.helper';
import { UserModel } from '../../../Core/Users/models/user.model';

export class SharedReportListItemModel {
    @Clonable()
    id: number;
    @Clonable()
    guid: string;
    @Clonable()
    name: string;
    @Clonable()
    reportId: number;
    @Clonable()
    fromName: string;
    @Clonable()
    expiryDate: Date;

    @Clonable()
    createdByUserId: number;
    @Clonable()
    createdDate: Date;
    @Clonable()
    modifiedByUserId: number;
    @Clonable()
    modifiedDate?: Date;
    @Clonable()
    createdBy?: string;

    sourceReportId: number;

    /**
     * Class constructor
     */
    constructor(apiModel: SharedReportListItemApiModel) {
        this.id = apiModel.id;
        this.guid = apiModel.guid;
        this.name = apiModel.name;
        this.reportId = apiModel.sourceReportId;
        this.fromName = apiModel.fromName;
        this.expiryDate = new Date(apiModel.expiryDate);
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.modifiedByUserId = apiModel.lastModifiedByUserId;
        this.modifiedDate = new Date(apiModel.lastModifiedDate);
        this.sourceReportId = apiModel.sourceReportId;
    }

    /**
     * Deep compare against another shared report model
     */
    public equals(other: SharedReportListItemModel): boolean {
        return true;
    }

    /**
     * Returns a clone of this SharedReportListItemModel
     */
    public clone(): SharedReportListItemModel {
        return basicClone(this);
    }
}
